import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import {CvSubmit} from '@app/model/cvSubmit';
import {CvsubmitSerializer} from '@app/model/serializer/cvsubmit-serializer';


@Injectable({ providedIn: 'root' })
export class CvSubmitService extends ApiService<CvSubmit> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'cvsubmit',
      new CvsubmitSerializer());
  }

}
